// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b4N9","clinicsSelect":"styles_clinicsSelect__2ZAvo"};